import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

const LoginPage = () => (
	<Redirect to="/" />
)

export default LoginPage;


// WEBPACK FOOTER //
// ./src/routes/login/index.js